import { AtlasTranslateConfig, isNullOrUndefined } from "@asfinag/atlas";
import { environment } from "src/environments/environment";

export enum SupportedLanguage {
	De = "de",
}

export const defaultLanguage = SupportedLanguage.De;

/**
 * use to get translations for webcams, roads, provinces endpoints
 */
export const languageShortcodes: { [key in SupportedLanguage]: string } = {
	de: "atDE",
};

export const TRANSLATE_CONFIG: AtlasTranslateConfig = {
	checkBrowserLanguageOnInit: true,
	defaultLanguage,
	isRemoteTranslationDataValidFn: (response) => !isNullOrUndefined(response) && response.length > 0,
	languages: [{ displayText: "Deutsch", shortcode: "de", urlSuffix: "de.json" }],
	localTranslationUrl: "./assets/i18n/de.json",
	remoteTranslationUrl: environment.urls.translations,
	useLocalTranslation: environment.useLocalTranslation,
};
